export const LOGOUT = 'LOGOUT';
export const MY_ACCOUNT = 'MY_ACCOUNT';
export const APPLY = 'APPLY';
export const MEMBER_CARD = 'MEMBER_CARD';
